import * as React from "react";

// An enum with all the types of actions to use in our reducer
export enum RunShrinkVolumeReducerActionType {
  LOCATION = "LOCATION",
  INDEX = "INDEX",
  NEW_STORAGE_CAPACITY = "NEW_STORAGE_CAPACITY",
  TIMEOUT_SECONDS = "TIMEOUT_SECONDS",
}

// An interface for our actions
interface RunShrinkVolumeReducerAction {
  type: RunShrinkVolumeReducerActionType;
  payload: any;
}

// An interface for our state
export interface ShrinkVolumeReducerState {
  location: string;
  volumeIndex: string;
  newStorageCapacity: string;
  timeoutSeconds: string;
}

// Our reducer function that uses a switch statement to handle our actions
function runShrinkVolume(state: ShrinkVolumeReducerState, action: RunShrinkVolumeReducerAction) {
  const { type, payload } = action;
  switch (type) {
    case RunShrinkVolumeReducerActionType.LOCATION:
      return {
        ...state,
        location: payload,
      };
    case RunShrinkVolumeReducerActionType.INDEX:
      return {
        ...state,
        volumeIndex: payload,
      };
    case RunShrinkVolumeReducerActionType.NEW_STORAGE_CAPACITY:
      return {
        ...state,
        newStorageCapacity: payload,
      };
    case RunShrinkVolumeReducerActionType.TIMEOUT_SECONDS:
      return {
        ...state,
        timeoutSeconds: payload,
      };
    default:
      return state;
  }
}

export function useRunShrinkVolumeReducer(
  initialLocation: string | undefined,
  initialVolumeIndex: string | undefined,
  initialStorageCapacity: string | undefined,
  timeoutSeconds: string | undefined,
) {
  const initialState: ShrinkVolumeReducerState = {
    location: initialLocation || "",
    volumeIndex: initialVolumeIndex || "",
    newStorageCapacity: initialStorageCapacity || "0",
    timeoutSeconds: timeoutSeconds || "600",
  };
  return React.useReducer(runShrinkVolume, initialState);
}
